import { createAction } from "redux-smart-actions";
import { SagaActionParams, SagaGenericParams } from "../base/types/saga";
import { takeLatest } from "@redux-saga/core/effects";
import { getListSaga } from "../base/getListSaga";
import { Slider } from "./types/Slider";
import { Period } from "./types/period";
import { KMLimit } from "./types/kmLimit";
import { ExtraService } from "./types/extraService";
import { RentalConditions } from "./types/rentalConditions";
import { Price } from "../cars/types/carDetail";
import { SocialMedia } from "./types/socialmedia";
import { postSaga, PostSagaGenericParams } from "../base/postSaga";

export const createContact = createAction(
  "CREATE_CONTACT",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "System/contact",
    body,
  })
);

export const getSliderList = createAction(
  "GET_SLIDERS",
  ({ payload, url }: SagaActionParams<Slider[]>) => ({
    payload,
    url,
  })
);

export const getPeriodList = createAction(
  "GET_PERIODS",
  ({ payload, url }: SagaActionParams<Period[]>) => ({
    payload,
    url,
  })
);
export const getSocialMedia = createAction(
  "GET_SOCIAL_MEDIA",
  ({ payload, url }: SagaActionParams<SocialMedia>) => ({
    payload,
    url,
  })
);

export const getkmlimitList = createAction(
  "GET_KMLIMITS",
  ({ payload, url }: SagaActionParams<KMLimit[]>) => ({
    payload,
    url,
  })
);

export const getExtraService = createAction(
  "GET_EXTRASERVICES",
  ({ payload, url }: SagaActionParams<ExtraService[]>) => ({
    payload,
    url,
  })
);

export const getCarPriceList = createAction(
  "GET_CAR_PRICE_LIST",
  ({ payload, url }: SagaActionParams<Price[]>) => ({
    payload,
    url,
  })
);

export const getRentalConditionList = createAction(
  "GET_RENTALCONDITIONS",
  ({ payload, url }: SagaActionParams<RentalConditions>) => ({
    payload,
    url,
  })
);

const getDefinitions = [
  takeLatest(createContact.toString(), (payload: PostSagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
  takeLatest(getSliderList.toString(), (payload: SagaGenericParams<Slider[]>) =>
    getListSaga<Slider[]>(payload)
  ),
  takeLatest(getPeriodList.toString(), (payload: SagaGenericParams<Period[]>) =>
    getListSaga<Period[]>(payload)
  ),
  takeLatest(
    getkmlimitList.toString(),
    (payload: SagaGenericParams<KMLimit[]>) => getListSaga<KMLimit[]>(payload)
  ),
  takeLatest(
    getSocialMedia.toString(),
    (payload: SagaGenericParams<SocialMedia>) =>
      getListSaga<SocialMedia>(payload)
  ),
  takeLatest(
    getExtraService.toString(),
    (payload: SagaGenericParams<ExtraService[]>) =>
      getListSaga<ExtraService[]>(payload)
  ),
  takeLatest(
    getRentalConditionList.toString(),
    (payload: SagaGenericParams<RentalConditions>) =>
      getListSaga<RentalConditions>(payload)
  ),
  takeLatest(
    getCarPriceList.toString(),
    (payload: SagaGenericParams<Price[]>) => getListSaga<Price[]>(payload)
  ),
];

export default getDefinitions;
